module.exports = __webpack_public_path__ + "img/zoom3.7ed05b88.png";